/*global payhere*/
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ImgPay from '../assets/ImgPay.svg';

const apiBase = process.env.REACT_APP_API;

const PayOnline = ({ setCartItemCount }) => {
  const [userDetail, setUserDetail] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "Sri Lanka",
  });
  const [cartItem, setCartItem] = useState(null);
  const navigate = useNavigate();
  const storedItem = JSON.parse(localStorage.getItem("cartItems"));

  useEffect(() => {
    const fetchProfileData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const response = await fetch(`${apiBase}/profile`, {
          method: "POST",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setUserDetail({
            first_name: data.profile[0].first_name,
            last_name: data.profile[0].last_name,
            email: data.profile[0].email,
            phone: data.profile[0].phone_number,
            address: data.profile[0].address,
            city: data.profile[0].city,
            country: data.profile[0].country,
          });
        }
      } catch (err) {
        console.log(err);
        alert("please try again later");
        navigate("/");
      }
    };

    fetchProfileData();
  }, []);

  useEffect(() => {
    const fetchCartItem = async () => {
      const storedItem = JSON.parse(localStorage.getItem("cartItems"));
      if (!storedItem) return;

      try {
        const response = await fetch(`${apiBase}/payments/cart`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ course_id: storedItem.course_id }),
        });
        const itemDetails = await response.json();
        setCartItem({ ...storedItem, ...itemDetails[0] });
      } catch (error) {
        console.error("Error fetching cart item details:", error);
      }
    };

    fetchCartItem();
  }, []);

  const handlePayment = async () => {
    const paymentDetails = {
      amount: cartItem.price.toFixed(2),
      month: cartItem.month,
      year: String(cartItem.year),
      course_id: storedItem.course_id,
    };

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiBase}/payments/start/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(paymentDetails),
      });

      if (response.ok) {
        const { hash, merchant_id, order_id } = await response.json();

        payhere.onCompleted = function onCompleted() {
          localStorage.removeItem("cartItems");
          setCartItemCount(0);
          navigate("/profile");
        };

        const payment = {
          sandbox: true,
          merchant_id: merchant_id,
          return_url: "http://localhost:3000/payment/success",
          cancel_url: "http://localhost:3000/payment/cancel",
          notify_url: "https://api-janith-lms.vercel.app/payments/notify/",
          order_id: order_id,
          items: "Item Title",
          amount: paymentDetails.amount,
          currency: "LKR",
          first_name: userDetail.first_name,
          last_name: userDetail.last_name,
          email: userDetail.email,
          phone: userDetail.phone,
          address: userDetail.address,
          city: userDetail.city,
          country: userDetail.country,
          hash: hash,
        };

        if (typeof payhere !== "undefined") {
          payhere.startPayment(payment);
        } else {
          console.error("PayHere SDK not loaded");
        }
      } else {
        console.error("Failed to generate hash for payment.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div className="mt- mb-8 px-4 h flex flex-col justify-center items-center">
      <img src={ImgPay} alt="" className="size-[800px] -translate-y-20"/>
      <button
        id="payhere-payment"
        onClick={handlePayment}
        className="-translate-y-56 mb-2 px-6 py-3 bg-green-600 hover:bg-opacity-75 text-white font-bold text-lg rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition duration-150"
      >
        PayHere Pay
      </button>
      <a href="https://www.payhere.lk" target="_blank" className="-translate-y-20"><img src="https://www.payhere.lk/downloads/images/payhere_long_banner.png" alt="PayHere"  height="400" className=""/></a>

    </div>
  );
};

export default PayOnline;
